import { AppLink } from '@/components/ui/app-link';
import { Badge } from '@/components/ui/badge';
import { useChatSpend } from '@/hooks/useBillingQueries';
import { cn } from '@/lib/utils';
import { formatAudPrecise } from '@/utils/money-utils';

interface ChatSpendPillProps {
  neoChatId?: number;
  className?: string;
}

export function ChatSpendPill({ neoChatId, className }: ChatSpendPillProps) {
  const query = useChatSpend(neoChatId);
  const spend = query.data;

  if (!neoChatId || !spend || spend.usageRecordCount === 0) {
    return null;
  }

  const approximate = spend.unsettledUsageCount > 0;
  const label = `${approximate ? '~' : ''}${formatAudPrecise(spend.spentAud)}`;
  const title = approximate
    ? 'Total spend for this chat so far — a charge is still settling. Open billing'
    : 'Total spend for this chat — open billing';

  return (
    <AppLink
      to="/settings/billing"
      data-testid="speak2me-chat-spend-pill"
      title={title}
      aria-label={title}
      onClick={(e) => e.stopPropagation()}
      className="shrink-0 no-underline"
    >
      <Badge
        variant="outline"
        className={cn(
          'h-5 px-1.5 text-[11px] font-medium tabular-nums leading-none text-muted-foreground transition-colors hover:text-foreground',
          className
        )}
      >
        {label}
      </Badge>
    </AppLink>
  );
}
